
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {CustomLink} from "theme/components/shared/common/CustomLink";


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "asf-infomation"
    }}>{`ASF Infomation`}</h1>
    <ol>
      <li parentName="ol">
        <CustomLink href="http://www.apache.org/foundation/how-it-works.html" mdxType="CustomLink">How Apache Works</CustomLink>
      </li>
      <li parentName="ol">
        <CustomLink href="https://apachecon.com/?ref=atlas.apache.org" mdxType="CustomLink">Events </CustomLink>
      </li>
      <li parentName="ol">
        <CustomLink href="https://www.apache.org/licenses/" mdxType="CustomLink">License </CustomLink>
      </li>
      <li parentName="ol">
        <CustomLink href="http://www.apache.org/foundation/" mdxType="CustomLink">Foundation </CustomLink>
      </li>
      <li parentName="ol">
        <CustomLink href="http://www.apache.org/foundation/sponsorship.html" mdxType="CustomLink">Sponsoring Apache </CustomLink>
      </li>
      <li parentName="ol">
        <CustomLink href="http://www.apache.org/foundation/thanks.html" mdxType="CustomLink">Thanks</CustomLink>
      </li>
    </ol>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;